<div class="industry-block"
     [ngStyle]="backgroundStyle"
     role="region"
     [attr.aria-label]="config?.title | translate">

  <div class="content">
    <div class="text-section">
      <h2 class="title" [innerHTML]="config?.title | translate | safe"></h2>

      <p class="text page-description">
        {{ config?.text | translate }}
      </p>

      <app-button
        class="button"
        [routerLink]="[config?.buttonLink]"
        [config]="{
          view: 'outlined',
          label: config?.buttonText,
          type: 'button'
        }"
        [attr.aria-label]="config?.buttonText">
      </app-button>

      <!-- Logos - Desktop/Tablet position -->
      <div class="logos logos-desktop" aria-label="Partner companies">
        @for (logo of config?.logos; track logo.src) {
          <img
            [ngSrc]="logo.src"
            [width]="logo.width"
            [height]="logo.height"
            [alt]="logo.alt"
            class="logo"
            loading="lazy" />
        }
      </div>
    </div>

    <div class="image-section">
      <figure class="image-wrapper">
        <img
          [src]="config?.image.src"
          [alt]="config?.image.alt"
          class="image"
          loading="lazy" />
      </figure>
    </div>
  </div>

  <!-- Logos - Mobile position -->
  <div class="logos logos-mobile" aria-label="Partner companies">
    @for (logo of config?.logos; track logo.src) {
      <img
        [ngSrc]="logo.src"
        [width]="logo.width"
        [height]="logo.height"
        [alt]="logo.alt"
        class="logo"
        loading="lazy" />
    }
  </div>
</div>
